// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"e8ec41d8","527":"233bad5e"}[chunkId] + ".chunk.js";
};